const baseUrl = `https://lyncare-deloy.vercel.app/api`;

export default baseUrl;